import { render } from "./Tickets.vue?vue&type=template&id=315f80c6&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=315f80c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-315f80c6"

export default script